<template>
  <div v-if="value.visible" class="el-dialog__wrapper" style="background-color: #0008; z-index: 2000;" @click="onCancel">

    <div class="my-preview-pop">
      <div class="px-4 py-2_5 row-end border-b">
        <el-button @click="onCancel">关闭</el-button>
        <el-button type="primary" :loading="$store.state.app.loadingList.includes('clone-' + params.formId)" @click="onOk">选用</el-button>
      </div>
      <div class="my-preview-wrapper">
        <iframe
          :src="params.url"
          style="width: 100%; height: 100%; border: 0px; display: block"
        />
      </div>
    </div>

  </div>

</template>

<script>
import { clone } from '@/api/tpl'
import { openPage } from '@/utils/index'

export default {
  name: 'DlgTplPreview',
  components: {
  },
  props: {
    // 原则上vue的props应该是只读的，但vue对对象中的内容没有监测，这里不管了，直接把modelValue当作可写的
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      const that = this
      console.log('ok')
      const workspaceId = localStorage.getItem('bd_webapp_orgId')
      const res = await clone({
        id: that.params.formId,
        query: `?org_id=${workspaceId}`
      }, 'clone-' + that.params.formId)

      this.value.visible = false
      openPage({
        name: 'FormUpdate',
        params: {
          id: res
        }
      }, this)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.my-preview-pop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 50%;
  z-index: 2001;
  padding: 0;
  background: #fff;
  border: 1px solid #ddd;
  transform: translateX(-50%);
  width: 960px;
  max-width: 100%;
  border-radius: 4px;
}
.my-preview-wrapper {
  height: calc(100vh - 60px);
}
</style>
